// friendlyCaptcha.directive.js
(function() {
  'use strict';

  angular
    .module('app.directives')
    .directive('friendlyCaptcha', friendlyCaptcha);

  friendlyCaptcha.$inject = ['$timeout', 'FriendlyCaptchaLoader'];

  function friendlyCaptcha($timeout, FriendlyCaptchaLoader) {
    return {
      restrict: 'E',
      scope: {
        sitekey: '@',
        lang: '@?',
        token: '=?',
        onReady: '&?',
        onError: '&?',
        onChange: '&?'
      },
      template: '<div class="frc-captcha"></div>',
      link: function(scope, element, attrs) {
        var container = element[0].querySelector('.frc-captcha'),
            stop = false,
            last = null;

        function findTokenInput() {
          return container.querySelector('input[name="frc-captcha-solution"]') ||
                 container.querySelector('input[name="frc-captcha-response"]') ||
                 element[0].querySelector('input[name="frc-captcha-solution"]') ||
                 element[0].querySelector('input[name="frc-captcha-response"]');
        }

        function syncToken() {
          var input = findTokenInput(),
              val = input ? (input.value || '') : '';

          if (val !== last) {
            // Check validity before updating last
            var wasValid = last && !last.startsWith('.');
            var isValid = val && !val.startsWith('.');

            last = val;

            if (isValid) {
              // New token is valid
              scope.$applyAsync(function() {
                scope.token = val;
                if (scope.onChange) {
                  scope.onChange({token: val});
                }
              });
            } else if (wasValid && !isValid) {
              // Token was valid but now invalid (expired/cleared)
              scope.$applyAsync(function() {
                scope.token = null;
                if (scope.onChange) {
                  scope.onChange({token: null});
                }
              });
            }
            // If neither was valid, don't trigger onChange
          }
        }

        function startWatching() {
          function onComplete() {
            syncToken();
          }

          function onErr(ev) {
            syncToken();
            scope.$applyAsync(function() {
              if (scope.onError) {
                scope.onError({event: ev});
              }
            });
          }

          container.addEventListener('frc:widget.complete', onComplete);
          container.addEventListener('frc:widget.error', onErr);
          container.addEventListener('frc:widget.expire', onComplete);

          (function poll() {
            if (stop) {
              return;
            }

            syncToken();
            $timeout(poll, 400);
          })();

          scope.$applyAsync(function() {
            if (scope.onReady) {
              scope.onReady();
            }
          });


          scope.$on('$destroy', function() {
            stop = true;
            container.removeEventListener('frc:widget.complete', onComplete);
            container.removeEventListener('frc:widget.error', onErr);
            container.removeEventListener('frc:widget.expire', onComplete);
          });
        }

        function applyAttributes() {
          var key = attrs.sitekey || scope.sitekey;

          if (!key) {
            return false;
          }
          
          container.setAttribute('data-sitekey', key);
          container.setAttribute('data-start', 'none');

          if (attrs.lang || scope.lang) {
            container.setAttribute('data-lang', attrs.lang || scope.lang);
          }

          return true;
        }

        attrs.$observe('sitekey', function() {
          if (!applyAttributes()) {
            return;
          }

          FriendlyCaptchaLoader.load(container)
            .then(function() {
              $timeout(startWatching, 0);
            })
            .catch(function(err) {
              scope.$applyAsync(function() {
                if (scope.onError) {
                  scope.onError({error: err});
                }
              });
            });
        });
      }
    };
  }
})();
